import { createSelector } from 'reselect';
import { icons } from 'images';

const instagramReachCurrentMonthSelection = (state) => state.crmSocial.instagramReachCurrentMonthSelection;
const instagramReachTwoMonthsAgo = (state) => state.crmSocial.instagramReachTwoMonthsAgo;
const instagramReachThreeMonthsAgo = (state) => state.crmSocial.instagramReachThreeMonthsAgo;
const instagramFollowerCount = (state) => state.crmSocial.instagramFollowerCount;

const instagramImpressionsCurrentMonthSelection = (state) => state.crmSocial.instagramImpressionsCurrentMonthSelection;
const instagramImpressionsTwoMonthsAgo = (state) => state.crmSocial.instagramImpressionsTwoMonthsAgo;
const instagramImpressionsThreeMonthsAgo = (state) => state.crmSocial.instagramImpressionsThreeMonthsAgo;

const instagramGenderData = (state) => state.crmSocial.instagramGenderData;
const instagramLocationData = (state) => state.crmSocial.instagramLocationData;
const instagramFollowerGrowth = (state) => state.crmSocial.followerGrowth;
const igEngagementRatePct = (state) => state.crmSocial.igEngagementRatePct;
const sumIgProfileViews = (state) => state.crmSocial.sumIgProfileViews;
const instagramSavedCount = (state) => state.crmSocial.savedCount;
const instagramSharedCount = (state) => state.crmSocial.sharesCount;

const formatInstagramInsights = (monthOne, monthTwo, monthThree) => {
  if (monthOne === null && monthTwo === null && monthThree == null) {
    return null;
  }
  return [monthThree, monthTwo, monthOne];
};

export const instagramPageReachThreeMonths = createSelector(instagramReachCurrentMonthSelection, instagramReachTwoMonthsAgo, instagramReachThreeMonthsAgo, (instagramReachOneMonthAgo, instagramReachTwoMonthsAgo, instagramReachThreeMonthsAgo) => {
  return formatInstagramInsights(instagramReachOneMonthAgo, instagramReachTwoMonthsAgo, instagramReachThreeMonthsAgo);
});

export const instagramPageImpressionsThreeMonths = createSelector(instagramImpressionsCurrentMonthSelection, instagramImpressionsTwoMonthsAgo, instagramImpressionsThreeMonthsAgo, (instagramImpressionsCurrentMonthSelection, instagramImpressionsTwoMonthsAgo, instagramImpressionsThreeMonthsAgo) => {
  return formatInstagramInsights(instagramImpressionsCurrentMonthSelection, instagramImpressionsTwoMonthsAgo, instagramImpressionsThreeMonthsAgo);
});

export const instagramAgeAndGenderDemographicsListData = createSelector(instagramGenderData, (instagramGenderData) => {
  if (instagramGenderData === null) {
    return null;
  }
  const sorted = Object.entries(instagramGenderData || {}).sort((a, b) => b[1] - a[1]);
  const final = Object.entries(sorted).reduce((all, item) => {
    let name = item[1][0] || '';
    let friendly = item[1][0] || '';
    if (name.includes('F.')) {
      friendly = name.replace('F.', 'Females ');
    }
    if (name.includes('M.')) {
      friendly = name.replace('M.', 'Males ');
    }
    all.push({ name: friendly, value: item[1][1] });
    return all;
  }, []);
  return (final || []).slice(0, 5);
});

export const savedAndSharedCountPieGraph = createSelector(instagramSavedCount, instagramSharedCount, (instagramSavedCount, instagramSharedCount) => {
  if (!instagramSavedCount && !instagramSharedCount) {
    return null;
  }
  return [
    { name: 'Saved', value: instagramSavedCount ? instagramSavedCount : 0 },
    { name: 'Shared', value: instagramSharedCount ? instagramSharedCount : 0 },
  ];
});

export const instagramLocationsTableViewSelector = createSelector(instagramLocationData, (instagramLocationData) => {
  if (instagramLocationData === null) {
    return null;
  }
  const sorted = Object.entries(instagramLocationData || {}).sort((a, b) => b[1] - a[1]);
  const final = Object.entries(sorted || {}).reduce((all, item, i) => {
    all.push({ label: item[1][0], value: item[1][1] });
    return all;
  }, []);
  return (final || []).slice(0, 5);
});

export const instagramStatsBarSelector = createSelector(instagramFollowerCount, instagramReachCurrentMonthSelection, instagramFollowerGrowth, igEngagementRatePct, sumIgProfileViews, (instagramFollowerCount, instagramReachCurrentMonthSelection, instagramFollowerGrowth, igEngagementRatePct, sumIgProfileViews) => {
  const reach = (instagramReachCurrentMonthSelection || {}).Reach ? (instagramReachCurrentMonthSelection || {}).Reach : null;
  return [
    {
      name: 'Followers',
      value: instagramFollowerCount ? instagramFollowerCount.toLocaleString() : '...',
      isLive: true,
      isPlural: true,
      icon: icons['icon-social-likes'],
    },
    {
      name: 'Followers Growth',
      value: instagramFollowerGrowth ? instagramFollowerGrowth.toLocaleString() : '...',
      isLive: false,
      isPlural: false,
      icon: icons['icon-social-follower-growth'],
    },
    {
      name: 'Engagement Rate',
      value: igEngagementRatePct ? `${igEngagementRatePct.toFixed(2)}%` : '...',
      isLive: false,
      isPlural: false,
      icon: icons['icon-social-engagement-rate'],
    },
    {
      name: 'Profile Views',
      value: sumIgProfileViews ? sumIgProfileViews.toLocaleString() : '...',
      isLive: false,
      icon: icons['icon-social-reach'],
      isPlural: true,
      additionalInformation: [{ title: 'Organic' }, { title: 'Paid' }],
    },
    {
      name: 'Reach',
      value: reach ? reach.toLocaleString() : '...',
      icon: icons['icon-social-user-reach'],
      additionalInformation: [{ title: 'Organic' }, { title: 'Paid' }],
    },
  ];
});
